import React from "react";

const sizes = {
  sm: { padding: "12px 26px", fontSize: "var(--fs-micro)" },
  md: { padding: "16px 40px", fontSize: "var(--fs-eyebrow)" },
  lg: { padding: "19px 52px", fontSize: "var(--fs-caption)" },
};

/** Primary call-to-action. Wide-tracked caps on a hairline or solid field. */
export function Button({
  variant = "solid",
  size = "md",
  tone = "default",
  as = "button",
  href,
  full = false,
  disabled = false,
  children,
  style,
  ...rest
}) {
  const base = {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "10px",
    minHeight: 44,
    width: full ? "100%" : "auto",
    fontFamily: "var(--font-caps)",
    letterSpacing: "var(--ls-widest)",
    textTransform: "uppercase",
    lineHeight: 1,
    borderRadius: "var(--radius-none)",
    cursor: disabled ? "not-allowed" : "pointer",
    opacity: disabled ? 0.45 : 1,
    transition:
      "background var(--dur-fast) var(--ease-standard), color var(--dur-fast) var(--ease-standard), opacity var(--dur-fast) var(--ease-standard), transform var(--dur-instant) var(--ease-standard)",
    ...sizes[size],
  };
  const dark = tone === "onDark";
  const variants = {
    solid: { background: "var(--accent)", color: "var(--accent-contrast)", border: "var(--border-hair) solid var(--accent)" },
    outline: {
      background: dark ? "color-mix(in srgb, var(--fg-on-contrast) 5%, transparent)" : "color-mix(in srgb, var(--accent) 5%, transparent)",
      color: dark ? "var(--fg-on-contrast)" : "var(--fg-primary)",
      border: "1px solid " + (dark ? "color-mix(in srgb, var(--accent) 70%, transparent)" : "color-mix(in srgb, var(--accent) 58%, transparent)"),
      boxShadow: dark
        ? "inset 0 0 0 4px color-mix(in srgb, var(--fg-on-contrast) 5%, transparent)"
        : "inset 0 0 0 4px color-mix(in srgb, var(--accent) 6%, transparent), 0 14px 26px -20px color-mix(in srgb, var(--accent) 85%, transparent)",
    },
    ghost: { background: "transparent", color: dark ? "var(--fg-on-contrast)" : "var(--fg-secondary)", border: "var(--border-hair) solid transparent", padding: "8px 4px" },
    contrast: { background: "var(--bg-contrast)", color: "var(--fg-on-contrast)", border: "var(--border-hair) solid var(--bg-contrast)" },
  };
  const Tag = as === "a" ? "a" : "button";
  return (
    <Tag
      href={href}
      disabled={Tag === "button" ? disabled : undefined}
      style={{ ...base, ...variants[variant], ...style }}
      onMouseDown={(e) => { if (!disabled) e.currentTarget.style.transform = "scale(var(--press-scale))"; }}
      onMouseUp={(e) => { e.currentTarget.style.transform = "none"; }}
      onMouseEnter={(e) => { if (!disabled && variant === "outline") e.currentTarget.style.background = dark ? "color-mix(in srgb, var(--fg-on-contrast) 12%, transparent)" : "var(--accent-soft)"; }}
      onMouseLeave={(e) => { e.currentTarget.style.transform = "none"; if (variant === "outline") e.currentTarget.style.background = dark ? "color-mix(in srgb, var(--fg-on-contrast) 5%, transparent)" : "color-mix(in srgb, var(--accent) 5%, transparent)"; }}
      {...rest}
    >
      {children}
    </Tag>
  );
}
